<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading&&kpidata">
            <v-layout row wrap>
                <v-flex xs6 md3>
                    <v-card flat>
                        <v-card-title class="primary white--text headline">
                            Last hour
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['COP last hour']" :unit="kpidata['COP last hour'].unit"
                                           :value="kpidata['COP last hour'].kpi_value"
                                           icon=""
                                           :title="'COP last hour'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['Recent Cooling Load']"
                                           :unit="kpidata['Recent Cooling Load'].unit"
                                           :value="kpidata['Recent Cooling Load'].kpi_value"
                                           icon=""
                                           :title="'Cooling Load Last hour'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="lastActiveChillers"
                                           :unit="''"
                                           use-int
                                           :value="lastActiveChillers"
                                           icon=""
                                           :title="'Active Chillers'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['Electricity Used last hour']"
                                           :unit="kpidata['Electricity Used last hour'].unit"
                                           :value="kpidata['Electricity Used last hour'].kpi_value"
                                           icon=""
                                           :title="'Energy Consumption Last Hour'">
                                </value-box>
                            </v-flex>

                        </v-layout>

                    </v-card>
                </v-flex>
                <v-flex xs6 md3>
                    <v-card flat>
                        <v-card-title class="primary white--text headline">
                            Current Status
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['Header CHWS Temp']" :unit="kpidata['Header CHWS Temp'].unit"
                                           :value="kpidata['Header CHWS Temp'].kpi_value"
                                           icon=""
                                           :title="'Header CHWS Temp'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['Header CHWR Temp']" :unit="kpidata['Header CHWR Temp'].unit"
                                           :value="kpidata['Header CHWR Temp'].kpi_value"
                                           icon=""
                                           :title="'Header CHWR Temp'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="kpidata['Total Flow Rate']" :unit="kpidata['Total Flow Rate'].unit"
                                           :value="kpidata['Total Flow Rate'].kpi_value"
                                           icon=""
                                           :title="'Flow Rate'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md6>
                                <value-box v-if="lastOAT" :unit="'C'"
                                           :value="lastOAT"
                                           icon=""
                                           :title="'Outdoor Temperature'">
                                </value-box>
                            </v-flex>
                        </v-layout>

                    </v-card>
                </v-flex>
                <v-flex xs6 md6>
                    <v-card flat>
                        <v-card-title class="primary white--text headline">
                            YTD
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Cooling Load YTD']" :unit="kpidata['Cooling Load YTD'].unit"
                                           :value="kpidata['Cooling Load YTD'].kpi_value"
                                           :icon="kpidata['Cooling Load YTD'].kpi_value-kpidata['Cooling Load YTD Last Year'].kpi_value>0 ? 'fa-angle-up' : 'fa-angle-down'"
                                           icon-class="mr-2"
                                           :title="'Cooling Load YTD'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Electricity YTD']" :unit="kpidata['Electricity YTD'].unit"
                                           :value="kpidata['Electricity YTD'].kpi_value"
                                           :icon="kpidata['Electricity YTD'].kpi_value-kpidata['Electricity YTD Last Year'].kpi_value>0 ? 'fa-angle-up' : 'fa-angle-down'"
                                           icon-class="mr-2"
                                           :title="'Energy Consumption YTD'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Electricity MTD']" :unit="kpidata['Electricity MTD'].unit"
                                           :value="kpidata['Electricity MTD'].kpi_value"
                                           :icon="kpidata['Electricity MTD'].kpi_value-kpidata['Electricity MTD Last Year'].kpi_value>0 ? 'fa-angle-up' : 'fa-angle-down'"
                                           icon-class="mr-2"
                                           :title="'Energy Consumption MTD'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Cooling Load YTD Last Year']"
                                           :unit="kpidata['Cooling Load YTD Last Year'].unit"
                                           :value="kpidata['Cooling Load YTD Last Year'].kpi_value"
                                           icon=""
                                           :title="'Cooling Load YTD Last Year'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Electricity YTD Last Year']"
                                           :unit="kpidata['Electricity YTD Last Year'].unit"
                                           :value="kpidata['Electricity YTD Last Year'].kpi_value"
                                           icon=""
                                           :title="'Energy Consumption YTD Last Year'">
                                </value-box>
                            </v-flex>
                            <v-flex xs12 md4>
                                <value-box v-if="kpidata['Electricity MTD Last Year']"
                                           :unit="kpidata['Electricity MTD Last Year'].unit"
                                           :value="kpidata['Electricity MTD Last Year'].kpi_value"
                                           icon=""
                                           :title="'Energy Consumption MTD Last Year'">
                                </value-box>
                            </v-flex>
                        </v-layout>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
<!--        <v-flex xs6 v-show="!loading">-->
<!--            <v-layout row wrap v-if="kpidata">-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['COP last hour']" :unit="kpidata['COP last hour'].unit"-->
<!--                               :value="kpidata['COP last hour'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'COP last hour'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['Recent Cooling Load']"-->
<!--                            :unit="kpidata['Recent Cooling Load'].unit"-->
<!--                               :value="kpidata['Recent Cooling Load'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Recent Cooling Load'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['Last Cooling Forecast Accuracy']" :unit="kpidata['Last Cooling Forecast Accuracy'].unit"-->
<!--                               :value="kpidata['Last Cooling Forecast Accuracy'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Last Cooling Forecast Accuracy'"> -->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['Electricity Used last 30 days']" :unit="kpidata['Electricity Used last 30 days'].unit"-->
<!--                               :value="kpidata['Electricity Used last 30 days'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Electricity Used last 30 days'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['Last Chiller Power']" :unit="kpidata['Last Chiller Power'].unit"-->
<!--                               :value="kpidata['Last Chiller Power'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Last Chiller Power'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6 md3>-->
<!--                    <value-box v-if="kpidata['Last Chiller Power Prediction']" :unit="kpidata['Last Chiller Power Prediction'].unit"-->
<!--                               :value="kpidata['Last Chiller Power Prediction'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Last Chiller Power Prediction'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->

<!--            </v-layout>-->
<!--        </v-flex>-->

<!--        <v-flex xs6 v-show="!loading">-->
<!--            <v-layout row wrap v-if="kpidata">-->
<!--                <v-flex xs6>-->
<!--                    <value-box v-if="kpidata['Cooling Load YTD']" :unit="kpidata['Cooling Load YTD'].unit"-->
<!--                               :value="kpidata['Cooling Load YTD'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Cooling Load YTD'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6>-->
<!--                    <value-box v-if="kpidata['Electricity YTD']" :unit="kpidata['Electricity YTD'].unit"-->
<!--                               :value="kpidata['Electricity YTD'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Electricity YTD'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6>-->
<!--                    <value-box v-if="kpidata['Cooling Load YTD Last Year']" :unit="kpidata['Cooling Load YTD Last Year'].unit"-->
<!--                               :value="kpidata['Cooling Load YTD Last Year'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Cooling Load YTD Last Year'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--                <v-flex xs6>-->
<!--                    <value-box v-if="kpidata['Electricity YTD Last Year']" :unit="kpidata['Electricity YTD Last Year'].unit"-->
<!--                               :value="kpidata['Electricity YTD Last Year'].kpi_value"-->
<!--                               icon=""-->
<!--                               :title="'Electricity YTD Last Year'">-->
<!--                    </value-box>-->
<!--                </v-flex>-->
<!--            </v-layout>-->
<!--        </v-flex>-->

        <v-flex xs12 v-if="!loading">
            <yearly-energy-profile profile-only></yearly-energy-profile>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <v-card flat v-if="facility_name">
                <v-card-title class="primary white--text headline">
                    Optimisation Savings
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs8 v-if="data">
                        <vue-plotly show-export :data="data" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                    <v-flex xs4>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <value-box :value="totalSavingSum" unit="kWh" title="Saving after optimisation" icon="fa-piggy-bank" icon-size="40" icon-class="mr-4"></value-box>
                            </v-flex>
                            <v-flex xs6>
                                <value-box :value="totalPowerSum" unit="kWh" title="Actual usage after optimisation" icon="fa-bolt" icon-size="40" icon-class="mr-4"></value-box>
                            </v-flex>
                            <v-flex xs12>
                                <value-box :value="savingPercentage" unit="%" title="Saving" icon="fa-smile" class="green-icon" icon-size="40" icon-class="mr-4"></value-box>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Charts of Today
                </v-card-title>
            <v-layout row wrap>
                <v-flex xs6>
                    <cop-plot ref="plots"
                              :variable-x="'timestamp'"
                              :variable-y="'COP'"
                              :facility_name="facility_name"
                              :date-range="dailyRange"
                              :type="'scatter'"
                              :layout-overrides="{'yaxis':{'title':'COP'},'xaxis':{'title':'Time '}}"
                              just-plot
                    ></cop-plot>
                </v-flex>
                <v-flex xs6>
                    <cooling-load-stacked-area-plot agg="H" just-plot :date-range="dailyRange"></cooling-load-stacked-area-plot>
                </v-flex>
                <v-flex xs6>
                    <vue-plotly show-export v-if="data2" :data="data2" :layout="layout2" :options="options2"/>
                </v-flex>

                <v-flex xs6>

                    <multi-plot-chart v-if="chwVarList"
                                      :date-range="dailyRange"
                                      :variables-list="chwVarList"
                                      :layout-overrides="{'yaxis':{'title':'Temperature (°C)'},'xaxis':{'title':'Time '}}"
                                      just-plot
                    ></multi-plot-chart>
                </v-flex>
                <v-flex xs6 v-if="crpVarList&&!loading">
                    <multi-plot-chart
                                      :date-range="dailyRange"
                                      :variables-list="crpVarList"
                                      :layout-overrides="{'yaxis':{'title':'Temperature (°C)'},'xaxis':{'title':'Time '}}"
                                      just-plot
                    ></multi-plot-chart>
                </v-flex>
            </v-layout>
            </v-card>
        </v-flex>



        <v-flex xs12 v-show="!loading">
            <notifications dashboard-mode></notifications>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <maintenance-record></maintenance-record>

        </v-flex>
        <v-flex xs6 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Chiller Energy Consumption of Today
                </v-card-title>
            <vue-plotly show-export v-if="powerPieData" :data="powerPieData"  :layout="{width:'100%'}" :options="{}" ref="plotly"/>
            </v-card>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Chiller Running Time of Today
                </v-card-title>
            <vue-plotly show-export v-if="runningPieData" :data="runningPieData" :layout="{width:'100%'}"  :options="{}" ref="plotly"/>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy Distribution of Today
                </v-card-title>
                <vue-plotly v-if="starPie" :data="starPie" :layout="{height:800,width:800}"  :options="{}" ref="plotly"/>
            </v-card>
        </v-flex>



        <v-flex xs12 v-show="!loading">
            <anomaly-summary-view></anomaly-summary-view>
        </v-flex>




    </v-layout>
</template>

<script>
    import {callAPI,getKPI,findLineByLeastSquares} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import ValueBox from '@/components/ValueBox'
    import AnomalySummaryView from "./AnomalySummaryView";
    import moment from 'moment'
    import _ from 'lodash'
    import CopPlot from "../components/CopPlot";
    import MultiPlotChart from "../components/MultiPlotChart"
    import CoolingLoadStackedAreaPlot from '../components/CoolingLoadStackedAreaPlot'
    import MaintenanceRecord from "./MaintenanceRecord";
    import Notifications from "./Notifications";
    import YearlyEnergyProfile from "../components/YearlyEnergyProfile";



    export default {
        name: 'ShtDetailedDashboard',
        components: {VuePlotly,ValueBox,AnomalySummaryView,CopPlot,MultiPlotChart,CoolingLoadStackedAreaPlot,MaintenanceRecord,Notifications,YearlyEnergyProfile},
        computed: {
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },

            oatVar(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return 'Temperature';
                } else {
                    return 'Outdoor_Temperature';
                }

            },
            cutOff(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return "2019-11-26 00:00:00";
                } else {
                    return "2019-09-18 00:00:00";
                }

            },
            layout(){
                return ({
                            hovermode: 'closest',
                            xaxis: {
                                title: 'Average outdoor air temperature (°C)',
                                range:[15,35]
                            },
                            yaxis: {
                                range:this.$store.state.pointsListStore.pointsList.facility_name==="SHT" ? [0,6000] : "tozero",
                                title: 'Total energy consumption (kWh)',
                                rangemode:'tozero'
                            },
                            shapes:this.$store.state.pointsListStore.pointsList.facility_name==="SHT" ? [
                                {
                                    type: 'line',
                                    x0: 0,
                                    y0: -523.50,
                                    x1: 24.9,
                                    y1: 24.9*61.92-523.50,
                                    line:{
                                        color: 'rgb(31, 119, 180)',
                                        width: 2,
                                        dash:'dot'
                                    }
                                },
                                {
                                    type: 'line',
                                    x0: 24.9,
                                    y0: 24.9*61.92-523.50,
                                    x1: 40,
                                    y1: (40-24.9)*324.52+40*61.92-523.50,
                                    line:{
                                        color: 'rgb(31, 119, 180)',
                                        width: 2,
                                        dash:'dot'
                                    }
                                },
                            ] : []
                        })},
        },
        data () {
            return {
                showRecent: true,

                range: {start: '2019-09-25', end: '2019-10-01'},
                dailyRange:{
                    start:process.env.NODE_ENV === 'development' ? moment('2019-10-01').startOf('day').format('YYYY-MM-DD HH:mm') : moment().startOf('day').format('YYYY-MM-DD HH:mm'),
                    end:process.env.NODE_ENV === 'development' ? moment('2019-10-01').endOf('day').format('YYYY-MM-DD HH:mm') : moment().endOf('day').format('YYYY-MM-DD HH:mm')
                },
                kpidata:null,
                loading:false,
                forcedBlue:[
                    "2019-10-31 00:00:00",
                    "2019-10-29 00:00:00",
                    "2019-12-24 00:00:00",
                    "2019-12-25 00:00:00",
                    "2020-01-03 00:00:00",
                    "2020-01-07 00:00:00",
                ],
                equipment: null,
                lastOAT:null,
                lastActiveChillers:null,
                data:null,
                chwVarList:null,
                crpVarList:null,
                totalPowerSum:0,
                totalSavingSum:0,
                powerPieData:null,
                colorMap:{
                    "ACPC-1":"rgba(255, 127, 14,0.5)",
                    "ACPC-2":"rgba(214, 39, 40,0.5)",
                    "ACPC-3":"rgba(44, 160, 44, 0.5)",
                    "ACPC-4":"rgba(31, 119, 180,0.5)",
                    "ACPC-5": "rgba(148, 103, 189,0.5)",
                    "ACPC-6": "rgba(140, 86, 75,0.5)",
                    "ACPC-7": "rgba(227, 119, 194,0.5)",
                    "ACPC-8": "rgba(127, 127, 127,0.5)",
                    "ACPC-9": "rgba(188, 189, 34,0.5)",
                    "Chiller1": "rgba(255, 127, 14,0.5)",
                    "Chiller2": "rgba(214, 39, 40,0.5)",
                    "Chiller3": "rgba(44, 160, 44, 0.5)",
                    "Chiller4": "rgba(31, 119, 180,0.5)",
                    "Chiller5": "rgba(148, 103, 189,0.5)",
                    "Chiller6": "rgba(140, 86, 75,0.5)",
                    "Chiller7": "rgba(227, 119, 194,0.5)",
                    "Chiller8": "rgba(127, 127, 127,0.5)",
                    "Chiller9": "rgba(188, 189, 34,0.5)",
                    "Chiller_1A": "rgba(255, 127, 14,0.5)",
                    "Chiller_1B": "rgba(214, 39, 40,0.5)",
                    "Chiller_2": "rgba(44, 160, 44, 0.5)",
                    "Chiller_3": "rgba(31, 119, 180,0.5)",
                    "Chiller_4": "rgba(148, 103, 189,0.5)",
                    "Chiller_5": "rgba(140, 86, 75,0.5)",
                    "Chiller_6": "rgba(227, 119, 194,0.5)",
                    "Chiller_7": "rgba(127, 127, 127,0.5)",
                },
                starPie:null,
                runningPieData:null,
                data2:null,
                data3:null,
                data4:null,
                options: {},
                options2: {},
                options3: {},
                options4: {},

                layout2:{
                    yaxis: {
                        title: 'Energy consumption (kWh)'
                    },
                    xaxis: {
                        title: 'Time (hourly)',
                    }
                }


            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            }
        },
        beforeMount(){
            let maxDaily=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDaily){
                this.dailyRange={
                    start:moment(maxDaily).startOf('day').format('YYYY-MM-DD HH:mm'),
                    end: moment(maxDaily).endOf('day').format('YYYY-MM-DD HH:mm')
                }
            }
        },
        mounted() {
            let me=this;

            getKPI(
                {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name}
            ).then(function(kpidata){
                me.kpidata=kpidata.result.reduce(function(map, obj) {
                    map[obj.kpi_name] =obj;
                    return map;
                }, {});
            });


            let rangeStart = _.get(this.$route.query,'rangeStart', null)
            if(!rangeStart){
                rangeStart=this.facility_name=="SHT" ? "2019-08-27" : "2019-10-17"
            }
            let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
            me.loading=true;
            let promises=[];
            let promises2=[];
            let timestamp=null;
            let timestamp2=null;
            let totalPower=null;
            let avgTemp=null;
            let CHWVarList=[];
            let CRPVarList=[];
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(equip.equipment_type==='chiller'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['Comp_Power']
                        }
                    ))
                    promises2.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'H',
                            'agg_op': 'sum',
                            'date_range':[this.dailyRange.start,this.dailyRange.end],
                            'sensor_names': ['Comp_Power']
                        }
                    ))
                    CHWVarList.push({
                        equipment_name: equip.equipment_name,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        name: "CHWS_Temp",
                        line:{
                            color: this.colorMap[equip.equipment_name],
                            width: 2
                        }
                    })
                    CHWVarList.push({
                        equipment_name: equip.equipment_name,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        name: "CHWR_Temp",
                        line:{
                            color: this.colorMap[equip.equipment_name],
                            width: 2,
                            dash:'dot'
                        }
                    })
                    if(this.$store.state.pointsListStore.pointsList.facility_name=="CRP"){
                        CRPVarList.push({
                            equipment_name: equip.equipment_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            name: "CDWS_Temp",
                            line:{
                                color: this.colorMap[equip.equipment_name],
                                width: 2
                            }
                        })
                        CRPVarList.push({
                            equipment_name: equip.equipment_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            name: "CDWR_Temp",
                            line:{
                                color: this.colorMap[equip.equipment_name],
                                width: 2,
                                dash:'dot'
                            }
                        })
                    }
                } else if(equip.equipment_type==='pump'&&this.$store.state.pointsListStore.pointsList.facility_name!=="CRP"){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['KW']
                        }
                    ))
                    promises2.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'H',
                            'agg_op': 'sum',
                            'date_range':[this.dailyRange.start,this.dailyRange.end],
                            'sensor_names': ['KW']
                        }
                    ))
                }
            }
            this.chwVarList=CHWVarList;
            if(this.$store.state.pointsListStore.pointsList.facility_name=="CRP"){
                this.crpVarList=CRPVarList;
            }
            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': 'Weather',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': [me.oatVar]
                }
            ))


            Promise.all(promises).then(function(reses) {
                for (let res of reses){
                    if(!timestamp){
                        timestamp=res.data.timestamp;
                    }
                    if(res.data[me.oatVar]){
                        avgTemp=res.data[me.oatVar];
                        me.lastOAT=avgTemp[avgTemp.length-1]
                    } else {
                        if(!totalPower){
                            if(res.data['Comp_Power']){
                                totalPower=res.data['Comp_Power'];
                            } else if (res.data['KW']){
                                totalPower=res.data['KW'];
                            }
                        } else {
                            if(res.data['Comp_Power']){
                                totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                            } else if (res.data['KW']){
                                totalPower=me.addArrays(totalPower,res.data['KW'])
                            }
                        }
                    }

                }
                let preAvgTemp=[];
                let postAvgTemp=[];
                let preTotalPower=[];
                let postTotalPower=[];
                let preLabels=[];
                let postLabels=[];
                let totalPowerSum=0;
                let totalSavingSum=0;
                for (let k in timestamp){
                    if(timestamp[k]<=me.cutOff||(me.forcedBlue.includes(timestamp[k])&&me.$store.state.pointsListStore.pointsList.facility_name==="SHT")){
                        preAvgTemp.push(avgTemp[k]);
                        preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        preLabels.push(timestamp[k].substring(0, 10));
                    } else {
                        postAvgTemp.push(avgTemp[k]);
                        postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        postLabels.push(timestamp[k].substring(0, 10));
                    }
                }


                let trendBeforeCurb=findLineByLeastSquares(preAvgTemp,preTotalPower)
                let getY=function(x,trend){
                    return ((x*trend[0])+trend[1])
                }
                let trendBefore=[[15,35],[getY(15,trendBeforeCurb),getY(35,trendBeforeCurb)]]
                for (let k in postAvgTemp){
                    totalPowerSum+=postTotalPower[k];
                    if(me.$store.state.pointsListStore.pointsList.facility_name==="SHT"){
                        if(postAvgTemp[k]<24.9){
                            totalSavingSum+=(61.92*postAvgTemp[k])-523.5-postTotalPower[k];
                        } else {
                            totalSavingSum+=(61.92*postAvgTemp[k])-523.5-postTotalPower[k]+((postAvgTemp[k]-24.9)*324.52);
                        }

                    } else {
                        totalSavingSum+=(trendBeforeCurb[0]*postAvgTemp[k])+trendBeforeCurb[1]-postTotalPower[k];
                    }

                }
                me.totalPowerSum=totalPowerSum;
                me.totalSavingSum=totalSavingSum;
                if(me.$store.state.pointsListStore.pointsList.facility_name==="SHT"){
                    me.data = [
                        {
                            x: preAvgTemp,
                            y: preTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"Before optimisation",
                            hovertext:preLabels,
                            marker: {
                                color: 'rgb(31, 119, 180)',
                            }
                        },
                        {
                            x: postAvgTemp,
                            y: postTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"After optimisation",
                            hovertext:postLabels,
                            marker: {
                                color: 'rgb(255, 127, 14)',
                            }
                        }
                    ]
                } else {
                    me.data = [
                        {
                            x: preAvgTemp,
                            y: preTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"Before optimisation",
                            hovertext:preLabels,
                            marker: {
                                color: 'rgb(31, 119, 180)',
                            }
                        },
                        {
                            x: trendBefore[0],
                            y: trendBefore[1],
                            type: 'scattergl',
                            name:"Before optimisation trend",
                            mode: 'lines',
                            line: {
                                color: 'rgb(31, 119, 180)',
                                width: 2,
                                dash:'dot'
                            }
                        },
                        {
                            x: postAvgTemp,
                            y: postTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"After optimisation",
                            hovertext:postLabels,
                            marker: {
                                color: 'rgb(255, 127, 14)',
                            }
                        }
                    ]
                }

                me.loading=false;
            });
            Promise.all(promises2).then(function(reses) {
                let pieLabels=[];
                let piePower=[];
                let pie2Labels=[];
                let pie2Parent=[];
                let pie2Power=[];
                let pieRunning=[];
                let secondChartData = [];
                pie2Labels.push("Energy Consumption");
                pie2Parent.push("");
                pie2Labels.push("Chillers");
                pie2Labels.push("Pumps");
                pie2Parent.push("Energy Consumption");
                pie2Parent.push("Energy Consumption");
                let totalChiller=0;
                let totalPump=0;
                let chillersOn=0;
                for (let res of reses) {
                    if (!timestamp2) {
                        timestamp2 = res.data.timestamp;
                    }


                    if (res.data['Comp_Power']) {
                        if(res.data['Comp_Power'][res.data['Comp_Power'].length-1]>10){
                            chillersOn+=1;
                        }
                        pieLabels.push(JSON.parse(res.config.data)["equipment_name"]);
                        pie2Labels.push(JSON.parse(res.config.data)["equipment_name"]);
                        pie2Parent.push("Chillers");
                        let mormPower=res.data['Comp_Power'].map(i => i / me.$store.state.pointsListStore.pointsList.sampling_freq)
                        let running=0;
                        let power=0;
                        for(let val of mormPower){
                            if(val>10){
                                running+=1;
                            }
                            power+=val;
                        }
                        piePower.push(power);
                        pie2Power.push(power);
                        totalChiller+=power;
                        pieRunning.push(running);

                        secondChartData.push({
                            x: timestamp2,
                            y: mormPower,
                            name: JSON.parse(res.config.data)["equipment_name"],
                            fillcolor: me.colorMap[JSON.parse(res.config.data)["equipment_name"]],
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    } else if (res.data['KW']) {
                        pie2Labels.push(JSON.parse(res.config.data)["equipment_name"]);
                        pie2Parent.push("Pumps");
                        let mormPower=res.data['KW'].map(i => i / me.$store.state.pointsListStore.pointsList.sampling_freq)
                        let power=0;
                        for(let val of mormPower){
                            power+=val;
                        }
                        pie2Power.push(power);
                        totalPump+=power;
                        secondChartData.push({
                            x: timestamp2,
                            y: mormPower,
                            name: JSON.parse(res.config.data)["equipment_name"],
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    }

                }
                me.lastActiveChillers=chillersOn;
                secondChartData.sort((a, b) => (a.name > b.name) ? -1 : 1)
                me.data2 = secondChartData;
                me.powerPieData=[{
                    type:'pie',
                    labels:pieLabels,
                    values:piePower
                }];
                me.runningPieData=[{
                    type:'pie',
                    labels:pieLabels,
                    values:pieRunning
                }];
                pie2Power.unshift(totalPump);
                pie2Power.unshift(totalChiller);
                pie2Power.unshift(totalPump+totalChiller);
                me.starPie=[{
                    type:'sunburst',
                    labels:pie2Labels,
                    parents:pie2Parent,
                    values:pie2Power,
                    branchvalues: 'total'
                }]
            });



        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
</style>
